var _path, _path2, _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogobg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10631_113825)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.143 30C57.143 44.9905 44.9907 57.1428 30.0001 57.1428C15.0094 57.1428 2.85714 44.9905 2.85714 30C2.85714 15.0094 15.0094 2.85714 30.0001 2.85714C44.9907 2.85714 57.143 15.0094 57.143 30Z",
    stroke: "#5147FE",
    strokeWidth: 5.71429
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0003 50.3036C41.2136 50.3036 50.3037 41.2135 50.3037 30.0002C50.3037 18.787 41.2136 9.69683 30.0003 9.69683C18.787 9.69683 9.69683 18.787 9.69683 30.0002C9.69683 41.2135 18.787 50.3036 30.0003 50.3036Z",
    fill: "url(#paint0_linear_10631_113825)",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 0.606827
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10631_113825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 41,
    height: 41
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0003,
    cy: 30.0005,
    rx: 20,
    ry: 20,
    fill: "#635AFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10631_113825)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.12939 40.7344L6.82061 36.7113L54.6504 17.8228L55.7155 21.0968L8.12939 40.7344Z",
    fill: "url(#paint1_linear_10631_113825)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.426056 56.2222L-1.8584 49.1999L81.6278 16.2302L83.4869 21.945L0.426056 56.2222Z",
    fill: "url(#paint2_linear_10631_113825)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_10631_113825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.2762 23.0476L-7.09034 28.7555L57.9541 1.01219L53.308 -4.69577L-10.2762 23.0476Z",
    fill: "white",
    fillOpacity: 0.4
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10631_113825",
    x: -26.9639,
    y: -21.3836,
    width: 101.606,
    height: 66.8269,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.34387,
    result: "effect1_foregroundBlur_10631_113825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10631_113825",
    x1: 30.0003,
    y1: 49.3002,
    x2: 30.0003,
    y2: 10.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.262951,
    stopColor: "#7972FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10631_113825",
    x1: -7059.24,
    y1: 7351.13,
    x2: -5857.3,
    y2: 9791.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10631_113825",
    x1: -10564,
    y1: 12267.3,
    x2: -8467.5,
    y2: 16525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10631_113825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogobg);
export default __webpack_public_path__ + "static/media/logobg.16d6c742.svg";
export { ForwardRef as ReactComponent };